import { defaultClient } from '@/apollo/clients/default'

export default function useApolloClients() {
  return {
    default: defaultClient
  }
}
